export default "__VITE_ASSET__cc0c0f0d__"